import { BrowserRouter as Router, Routes,  Route, useLocation } from 'react-router-dom';
import MenuBar from '../components/menuBar';
import HomePage from '../pages/home';
import BeneficiarioPage from '../pages/beneficiario';
import CotacaoPage from '../pages/cotacao';
import CredenciadoPage from '../pages/credenciado';
import Footer from '../components/footer';
import LgpdPage from '../pages/lgpd';
import EntradaPage from '../pages/users/entrada';
import RouterProtect from './protect';
import QuemSomosPage from '../pages/quemSomos';
import NewBlog from '../pages/blog/new';

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import PostPage from '../pages/blog/post';
import ScrollToTop from '../context/scroll';
import Blogs from '../pages/blog';
import PainelControlePage from '../pages/painel';
import LoginPage from '../pages/users/login';

const AppRoutes = () => {

    
    const RenderRoutes = () => {
        
        const location = useLocation();
    
        const shouldShowMenuBar = location.pathname !== '/beneficiario';


        return (
            <>
            {shouldShowMenuBar && <MenuBar />}
            <ScrollToTop>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/minha-innova/admin" element={<LoginPage />} />
                    <Route path="/beneficiario" element={
                        <RouterProtect>
                            <BeneficiarioPage />
                        </RouterProtect>
                    } />
                    <Route path="/painel-de-controle" element={
                        // <RouterProtect>
                            <PainelControlePage />
                        // </RouterProtect>
                    } />
                    <Route path="/blog" element={<Blogs />} />
                    <Route path="/blog/new" element={<NewBlog />} />
                    <Route path="/blog/post/:slug" element={<PostPage />} />
                    <Route path="/quem-somos" element={<QuemSomosPage />} />
                    <Route path="/minha-innova" element={<EntradaPage />} />
                    <Route path="/credenciado" element={<CredenciadoPage />} />
                    <Route path="/proposta" element={<CotacaoPage />} />
                    <Route path="/politicas-de-privacidade-e-lgpd" element={<LgpdPage />} />
                </Routes>
            </ScrollToTop>
            </>
    )
}

    return (
        <Router>
            <ToastContainer />
            <RenderRoutes/>
            <Footer/>
        </Router>
    )
}
export default AppRoutes;